import { render, staticRenderFns } from "./TextLine.vue?vue&type=template&id=2dd47942"
import script from "./TextLine.vue?vue&type=script&lang=js"
export * from "./TextLine.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports